// extracted by css-extract-rspack-plugin
export default {"TooltipBackground":"TooltipBackground--H34OI"};